import { useState } from "react";

import { Collection, CollectionItem, FullItems } from "@/api";
import {
  ContentThumbnail,
  ContentTitle,
  Grid,
  AppCTAModal,
  DripLockedModal,
} from "@/components";
import { useAppCTAModal, useFullItems, useNavigateToItem } from "@/hooks";
import { useUser } from "@/providers/context";
import { cn, itemRequiresApp } from "@/utils";

export interface ContentGridProps {
  collection: Collection;
  fullItems: FullItems;
  items: CollectionItem[];
}

export const ContentGrid = ({
  collection,
  fullItems,
  items,
}: ContentGridProps) => {
  const { navigateToItem } = useNavigateToItem();
  const { getFullItem } = useFullItems(fullItems);
  const { modalOpen, modalItem, openAppCTAModal, setModalOpen } =
    useAppCTAModal();
  const [dripLockedModalOpen, setDripLockedModalOpen] = useState(false);
  const { isCollectionDripLocked } = useUser();

  return (
    <>
      <Grid>
        {items?.map((i) => {
          const fullItem = getFullItem(i);
          const showAppCTAModal = itemRequiresApp(fullItem);
          const isDripLocked =
            fullItem && "TabId" in fullItem
              ? isCollectionDripLocked(fullItem as Collection)
              : false;

          return (
            <div key={i.ChildId}>
              <ContentThumbnail
                className={cn(["w-full cursor-pointer rounded-[8px]"])}
                contentItem={fullItem}
                thumbnail={i.Thumbnail}
                onClick={() => {
                  if (showAppCTAModal && fullItem) {
                    openAppCTAModal(fullItem);
                    return;
                  }
                  if (isDripLocked) {
                    setDripLockedModalOpen(true);
                    return;
                  }

                  navigateToItem({
                    item: i,
                    parentId: collection.TabId,
                    fullItem,
                  });
                }}
                isDripLocked={isDripLocked}
              />
              <ContentTitle title={i.Title} />
            </div>
          );
        })}
      </Grid>
      <AppCTAModal open={modalOpen} setOpen={setModalOpen} item={modalItem} />
      <DripLockedModal
        open={dripLockedModalOpen}
        setOpen={setDripLockedModalOpen}
      />
    </>
  );
};
